import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-text">
            <p> Ben Homer</p>
          </div>
          <div className="footer-links">
            <a href="https://github.com/benhomer8" target="_blank" rel="noopener noreferrer" className="footer-link">
              GitHub
            </a>
            <a href="https://www.linkedin.com/in/benjamin-homer-9a96b82b5/" target="_blank" rel="noopener noreferrer" className="footer-link">
              LinkedIn
            </a>
            <a href="mailto:benhomer8@gmail.com" className="footer-link">
              Email
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
